<template>
  <div v-if="id" class="dispatch-board">
    <div class="row">
      <div v-if="$can('navigate', 'jobs')" class="col-xl-2 col-md-5 col-12 mb-xl-0 mb-4">
        <job-list
          :create-action="createJob"
          :current-job-id="id"
          :goto-action="gotoJob"
          :navigate-after-reset="true"
        />
      </div>

      <div
        v-if="$can('navigate', 'jobs')"
        :class="[currentJobClass]"
        class="col-xl-3 col-md-7 col-12"
      >
        <header class="job-header row">
          <div class="col">
            <b>JOB #{{ id }}</b>
          </div>
          <div class="col header-icons text-right">
            <div class="d-inline-block">
              <follow-up-dice :job="currentJob" classes="status-color" />
            </div>

            <div
              v-if="currentJob.status !== 'Draft' && $can('read', 'jobs', 'reminders')"
              class="d-inline-block position-relative text-left"
            >
              <reminder-icon :job="currentJob" />
            </div>
          </div>
        </header>

        <b-card :class="currentJob | jobStatusClass" class="mb-xl-0 mb-4 status-border" no-body>
          <b-tabs v-model="tabIndex" card>
            <b-tab active class="min-height" title="General">
              <job-edit ref="jobEdit" :current-job-id="id"></job-edit>
            </b-tab>
            <b-tab
              v-if="$store.state.jobs.currentJob.brand_id !== null"
              :title="`Appointment (${$lodash.get($refs, 'appointments.total', 0)})`"
              class="fixed-height"
            >
              <appointments
                ref="appointments"
                :current-job-id="id"
                :job="currentJob"
              ></appointments>
            </b-tab>
            <b-tab
              v-if="$store.state.jobs.currentJob.brand_id !== null && $can('read', 'invoices')"
              :title="`Invoice (${$lodash.get($refs, 'invoices.total', 0)})`"
              class="fixed-height"
            >
              <invoices ref="invoices" :current-job-id="id"></invoices>
            </b-tab>
            <b-tab
              v-if="$store.state.jobs.currentJob.brand_id !== null"
              :title="`Activity (${$lodash.get($refs, 'activities.total', 0)})`"
            >
              <activities ref="activities" :current-job-id="id"></activities>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

      <div :class="$can('navigate', 'jobs') ? 'col-xl-7' : 'col-xl-12'">
        <availability
          :current-job-id="id"
          :init-date="$store.state['tech-availability'].currentDate"
          :simple-mode="!$can('read', 'availabilities', 'full-mode')"
          class="mb-lg-4 mb-xl-0"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import JobList from "../../components/common/JobList.vue";
import JobEdit from "./partials/Edit.vue";
import Appointments from "./partials/Appointments.vue";
import Activities from "./partials/Activities.vue";
import Invoices from "./partials/Invoices.vue";
import Availability from "../../components/common/Availability.vue";
import ReminderIcon from "./partials/ReminderIcon.vue";
import EventBus from "../../imports/event-bus";

export default {
  components: {
    JobList,
    JobEdit,
    Appointments,
    Activities,
    Invoices,
    Availability,
    ReminderIcon,
  },

  data() {
    return {
      tabIndex: 0,
    };
  },

  computed: {
    id() {
      if (this.$route.params.id) {
        return Number(this.$route.params.id);
      }

      return false;
    },

    currentJob() {
      return this.$lodash.get(this.$store.state, "jobs.currentJob");
    },

    currentJobClass() {
      if (this.currentJob && this.currentJob.status) {
        return `status-${this.currentJob.status.split(" ").join("-").toLowerCase()}`;
      }

      return "";
    },

    statusClass() {
      if (this.$store.state.jobs.currentJob) {
        return `status-${this.$store.state.jobs.currentJob.status
          .split(" ")
          .join("-")
          .toLowerCase()}`;
      }

      return null;
    },
  },

  /* eslint-disable object-shorthand */
  watch: {
    "$route.params.id"() {
      if (!this.$route.params.id) {
        this.$store.dispatch("jobs/reset", {
          listQuery: {},
          navigateAfterReset: true,
        });
      }

      this.tabIndex = 0;
      this.$store.commit("jobs/setJobTab", this.tabIndex);
    },
    tabIndex() {
      if (this.tabIndex === 1) {
        // Viewed appointments tab, record this
        this.$store.dispatch("audit/addJobId", this.id);
      }
      this.$store.commit("jobs/setJobTab", this.tabIndex);

      if (!this.$store.state["tech-availability"].lockFilters && this.tabIndex === 1) {
        this.$store.commit("tech-availability/startFiltering");
        this.$store.dispatch("tech-availability/filter");
      }
    },
  },

  mounted() {
    EventBus.$on("change-job-tab", (id) => {
      this.gotoTab(id);
    });

    if (!this.id) {
      this.$store.dispatch("jobs/reset", {
        listQuery: {},
        navigateAfterReset: true,
      });
    }
  },

  beforeUnmount() {
    this.$store.commit("tech-availability/resetAllDrawnIds");
  },

  methods: {
    createJob() {
      window.toastr.remove();

      this.$store.dispatch("jobs/create");
    },

    gotoJob(id) {
      window.toastr.remove();

      this.$store.commit("tech-availability/resetSelectedAppointment", null, { root: true });

      this.$router.push({
        name: "jobs.edit",
        params: { id },
      });
    },

    gotoTab(id) {
      this.tabIndex = id;
    },
  },
};
</script>
